// Shared constants & Indonesian formatting helpers

export const SERVICE_GROUPS = [
  {
    label: "Layanan Bidan Neny",
    options: [
      "Periksa Kehamilan – Bidan Neny",
      "Konsultasi Kehamilan – Bidan Neny",
      "Konsultasi Persiapan Persalinan – Bidan Neny",
      "Konsultasi KB – Bidan Neny",
      "Pelayanan KB – Bidan Neny",
    ],
  },
  {
    label: "Prenatal Yoga",
    options: ["Prenatal Yoga Pemula", "Prenatal Yoga Reguler", "Prenatal Yoga >34 Minggu"],
  },
];

export const ALL_SERVICES = SERVICE_GROUPS.flatMap((g) => g.options);

export const STATUSES = [
  "Baru",
  "Menunggu Konfirmasi",
  "Dikonfirmasi",
  "Reschedule",
  "Sudah Datang",
  "Selesai",
  "Batal",
  "No Show",
];

export const STATUS_STYLES = {
  Baru: "bg-slate-100 text-slate-700 border-slate-200",
  "Menunggu Konfirmasi": "bg-amber-100 text-amber-800 border-amber-200",
  Dikonfirmasi: "bg-sky-100 text-sky-800 border-sky-200",
  Reschedule: "bg-orange-100 text-orange-800 border-orange-200",
  "Sudah Datang": "bg-indigo-100 text-indigo-800 border-indigo-200",
  Selesai: "bg-emerald-100 text-emerald-800 border-emerald-200",
  Batal: "bg-rose-100 text-rose-800 border-rose-200",
  "No Show": "bg-neutral-200 text-neutral-700 border-neutral-300",
};

export function serviceCategory(s = "") {
  const v = String(s || "");
  if (v.startsWith("Prenatal Yoga")) return "yoga";
  if (v.includes("KB")) return "kb";
  return "bidan";
}

export const SERVICE_STYLES = {
  yoga: "bg-purple-100 text-purple-800 border-purple-200",
  kb: "bg-teal-100 text-teal-800 border-teal-200",
  bidan: "bg-rose-100 text-rose-800 border-rose-200",
};

export function isKB(s = "") {
  return String(s || "").includes("KB");
}
export function isYoga(s = "") {
  return String(s || "").startsWith("Prenatal Yoga");
}

const HARI = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
const BULAN = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

// Parse "YYYY-MM-DD" safely (no timezone shift)
function parseDate(iso) {
  if (!iso) return null;
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return null;
  return { y, m, d };
}

export function formatDateID(iso) {
  const p = parseDate(iso);
  if (!p) return "-";
  return `${String(p.d).padStart(2, "0")}/${String(p.m).padStart(2, "0")}/${p.y}`;
}

export function formatDateLong(iso) {
  const p = parseDate(iso);
  if (!p) return "-";
  const dt = new Date(p.y, p.m - 1, p.d);
  return `${HARI[dt.getDay()]}, ${p.d} ${BULAN[p.m - 1]} ${p.y}`;
}

export function todayWITA() {
  const now = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Makassar" }));
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function waLink(phone, message = "") {
  let p = (phone || "").replace(/[^0-9]/g, "");
  if (p.startsWith("0")) p = "62" + p.slice(1);
  else if (!p.startsWith("62")) p = "62" + p;
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  // api.whatsapp.com/send (bukan wa.me): redirect wa.me merusak emoji menjadi tanda tanya hitam.
  return `https://api.whatsapp.com/send?phone=${p}${text ? `&text=${encodeURIComponent(message)}` : ""}`;
}

// ---------- Transaction / omzet constants & helpers ----------
export const SERVICE_CATEGORIES = [
  "Bidan Neny", "Pemeriksaan Kehamilan", "Konsultasi", "KB", "Prenatal Yoga",
  "Mom & Baby Care", "Spa", "Homecare", "Kelas / Edukasi", "Layanan lainnya",
];
export const STAFF_TYPES = ["Bidan", "Terapis", "Dokter", "Admin", "Lainnya"];
export const LOCATIONS = ["GBS Clinic / Gerai", "Homecare", "Online", "Lainnya"];
export const PAYMENT_METHODS = ["Cash", "Transfer", "QRIS", "EDC", "Piutang", "Lainnya"];
export const PAYMENT_STATUSES = ["Belum Bayar", "DP", "Lunas", "Tanpa Bayar", "Refund"];
export const DISCOUNT_TYPES = ["Tidak ada", "Persentase", "Nominal"];
export const SPA_CATEGORIES = ["Spa", "Mom & Baby Care"];

export const PAYMENT_STATUS_STYLES = {
  "Belum Bayar": "bg-rose-100 text-rose-800 border-rose-200",
  DP: "bg-amber-100 text-amber-800 border-amber-200",
  Lunas: "bg-emerald-100 text-emerald-800 border-emerald-200",
  Refund: "bg-neutral-200 text-neutral-700 border-neutral-300",
};

export function formatRp(n) {
  return "Rp" + Number(n || 0).toLocaleString("id-ID");
}

// Parse an Indonesian-formatted currency string ("150.000", "Rp150.000") to a number.
export function parseRupiah(v) {
  if (typeof v === "number") return v;
  const digits = String(v || "").replace(/[^0-9]/g, "");
  return digits ? parseInt(digits, 10) : 0;
}

// Format a raw value into a grouped input string ("150000" -> "150.000").
export function formatRupiahInput(v) {
  const n = parseRupiah(v);
  return n ? n.toLocaleString("id-ID") : "";
}

// ---------- Dynamic booking fields (per-service, configured in Master Layanan) ----------
export const BOOKING_FIELD_CATALOG = [
  { key: "usia_kehamilan_minggu", label: "Usia Kehamilan (minggu)", type: "number", required: true, testid: "pb-uk", placeholder: "cth. 20", group: "Data Kehamilan" },
  { key: "kehamilan_ke", label: "Kehamilan ke-", type: "number", required: false, testid: "pb-kehamilan-ke", placeholder: "1", group: "Data Kehamilan" },
  { key: "hpl", label: "HPL (Hari Perkiraan Lahir)", type: "date", required: false, testid: "pb-hpl", group: "Data Kehamilan" },
  { key: "nama_bayi", label: "Nama Bayi / Anak", type: "text", required: true, testid: "pb-nama-bayi", placeholder: "Nama bayi", group: "Data Bayi / Anak" },
  { key: "tanggal_lahir_bayi", label: "Tanggal Lahir Bayi", type: "date", required: false, testid: "pb-dob-bayi", group: "Data Bayi / Anak" },
  { key: "jenis_kelamin_bayi", label: "Jenis Kelamin", type: "select", required: false, testid: "pb-jk-bayi", options: ["Laki-laki", "Perempuan"], group: "Data Bayi / Anak" },
  { key: "tanggal_lahir", label: "Tanggal Lahir", type: "date", required: false, testid: "pb-dob", group: "Data Diri" },
  { key: "jenis_kelamin", label: "Jenis Kelamin", type: "select", required: false, testid: "pb-jk", options: ["Laki-laki", "Perempuan"], group: "Data Diri" },
  { key: "hpht", label: "HPHT (Hari Pertama Haid Terakhir)", type: "date", required: false, testid: "pb-hpht", group: "Data Kehamilan" },
  { key: "alamat", label: "Alamat (terstruktur)", type: "address", required: false, testid: "pb-address", group: "Alamat" },
  { key: "tempat_lahir", label: "Tempat Lahir Bayi", type: "text", required: false, testid: "pb-tempat-lahir", group: "Data Bayi / Anak" },
  { key: "nik_anak", label: "NIK Anak", type: "text", numeric: true, maxLength: 16, required: false, testid: "pb-nik-anak", placeholder: "16 digit NIK anak", group: "Data Bayi / Anak" },
  { key: "nik_ibu", label: "NIK Ibu (jika anak belum punya NIK)", type: "text", required: false, testid: "pb-nik-ibu", group: "Data Bayi / Anak" },
  { key: "jenis_vaksin", label: "Jenis Imunisasi", type: "multiselect", required: false, testid: "pb-vaksin", options: ["HB-0", "BCG", "Polio", "DPT-HB-Hib", "IPV", "PCV", "Rotavirus", "MR", "JE", "Belum tahu / ingin konsultasi terlebih dahulu"], group: "Imunisasi" },
  { key: "tanggal_imunisasi_terakhir", label: "Tanggal Imunisasi Terakhir", type: "date", required: false, testid: "pb-imun-tgl", group: "Imunisasi" },
  { key: "imunisasi_terakhir", label: "Imunisasi Terakhir yang Diterima", type: "text", required: false, testid: "pb-imun-terakhir", group: "Imunisasi" },
  { key: "riwayat_kesehatan", label: "Catatan / Riwayat Kesehatan Khusus", type: "textarea", required: false, testid: "pb-riwayat", group: "Imunisasi" },
  { key: "consent_imunisasi", label: "Persetujuan Imunisasi", type: "consent", required: true, testid: "pb-consent", group: "Persetujuan" },
  { key: "nama_ibu", label: "Nama Ibu", type: "text", required: false, testid: "pb-nama-ibu", placeholder: "Nama ibu", group: "Data Bayi / Anak" },
];

export const CONSENT_TEXT = "Saya menyatakan bahwa data yang saya berikan benar dan memahami bahwa sebelum imunisasi akan dilakukan screening oleh tenaga kesehatan. Keputusan pemberian vaksin tetap berdasarkan hasil screening dan kondisi anak pada saat kunjungan.";

export const BOOKING_FIELD_MAP = Object.fromEntries(BOOKING_FIELD_CATALOG.map((f) => [f.key, f]));

// Fallback removed — booking fields are fully dynamic per service now.
export function heuristicBookingFields() {
  return [];
}

// Age from date of birth -> { y, m, d, text }
export function calcAgeParts(dob) {
  if (!dob) return null;
  const b = new Date(dob);
  if (isNaN(b.getTime())) return null;
  const n = new Date();
  let y = n.getFullYear() - b.getFullYear();
  let m = n.getMonth() - b.getMonth();
  let d = n.getDate() - b.getDate();
  if (d < 0) { m--; d += new Date(n.getFullYear(), n.getMonth(), 0).getDate(); }
  if (m < 0) { y--; m += 12; }
  if (y < 0) return null;
  return { y, m, d, text: `${y} tahun ${m} bulan ${d} hari` };
}

// Gestational age + HPL from HPHT (280-day rule)
export function calcPregnancy(hpht, refStr) {
  if (!hpht) return null;
  const h = new Date(hpht);
  if (isNaN(h.getTime())) return null;
  const ref = refStr ? new Date(refStr) : new Date();
  const diff = Math.floor((ref - h) / 86400000);
  const hplDate = new Date(h.getTime() + 280 * 86400000);
  const hpl = hplDate.toISOString().slice(0, 10);
  if (diff < 0) return { ukText: "-", weeks: 0, days: 0, hpl };
  return { ukText: `${Math.floor(diff / 7)} minggu ${diff % 7} hari`, weeks: Math.floor(diff / 7), days: diff % 7, hpl };
}

// Trimester label from gestational weeks
export function trimesterLabel(weeks) {
  if (weeks == null || weeks < 0) return "-";
  if (weeks < 14) return "Trimester 1";
  if (weeks < 28) return "Trimester 2";
  return "Trimester 3";
}

// Remaining time until HPL from a reference date
export function remainingToHPL(hpht, refStr) {
  if (!hpht) return null;
  const h = new Date(hpht);
  if (isNaN(h.getTime())) return null;
  const ref = refStr ? new Date(refStr) : new Date();
  const hplDate = new Date(h.getTime() + 280 * 86400000);
  const diff = Math.floor((hplDate - ref) / 86400000);
  if (diff <= 0) return { days: 0, text: "Sudah melewati / mendekati HPL" };
  return { days: diff, text: `${Math.floor(diff / 7)} minggu ${diff % 7} hari` };
}

// BMI + category (id: uses Indonesian labels)
export function calcBMI(heightCm, weightKg) {
  const h = Number(heightCm) / 100;
  const w = Number(weightKg);
  if (!h || !w || h <= 0 || w <= 0) return null;
  const bmi = w / (h * h);
  let cat, rec;
  if (bmi < 18.5) { cat = "Berat badan kurang (Underweight)"; rec = "12,5 – 18 kg"; }
  else if (bmi < 25) { cat = "Normal"; rec = "11,5 – 16 kg"; }
  else if (bmi < 30) { cat = "Berat badan berlebih (Overweight)"; rec = "7 – 11,5 kg"; }
  else { cat = "Obesitas"; rec = "5 – 9 kg"; }
  return { bmi: Math.round(bmi * 10) / 10, cat, rec };
}

// ---------- WhatsApp message templates ----------
export const DEFAULT_TEMPLATES = {
  tpl_confirm: `Halo Admin GBS Clinic, saya {nama} ingin konfirmasi reservasi:\n• Layanan: {layanan}\n• Kategori: {kategori}\n• Tanggal: {tanggal}\n• Jam: {jam}\n• Lokasi: {lokasi}\n• Petugas: {petugas}\nTerima kasih.`,
  tpl_reminder: `Assalamualaikum Kak {nama} 😊\nKami mengingatkan jadwal reservasi Kakak di GBS Clinic besok:\n📅 {tanggal}\n⏰ {jam}\n🌷 Layanan: {layanan}\n👩‍⚕️ Petugas: {petugas}\n📍 {lokasi}\nMohon hadir tepat waktu ya, Kak. Balas HADIR untuk konfirmasi kehadiran.\nTerima kasih 🙏\nGBS Clinic & Birth Center`,
  tpl_approved: `Halo Kak {nama} 🤍\nReservasi Anda di GBS Clinic sudah DIKONFIRMASI ✅\n• Layanan: {layanan}\n• Tanggal: {tanggal}\n• Jam: {jam}\n• Lokasi: {lokasi}\n• Petugas: {petugas}\nMohon hadir tepat waktu. Terima kasih 🤍\nGBS Clinic & Birth Center`,
  tpl_rejected: `Halo Kak {nama} 🤍\nMohon maaf, reservasi Anda di GBS Clinic:\n• Layanan: {layanan}\n• Tanggal: {tanggal}\n• Jam: {jam}\nbelum dapat kami konfirmasi. Silakan hubungi admin untuk memilih jadwal lain. Terima kasih atas pengertiannya 🤍\nGBS Clinic & Birth Center`,
  tpl_reschedule: `Halo Kak {nama} 🤍\nTerkait reservasi {layanan} di GBS Clinic, ada perubahan jadwal:\n• Tanggal baru: {tanggal}\n• Jam baru: {jam}\n• Lokasi: {lokasi}\n• Petugas: {petugas}\nMohon konfirmasi ketersediaan Anda. Terima kasih 🤍\nGBS Clinic & Birth Center`,
};

export function renderTemplate(tpl, data = {}) {
  return String(tpl || "").replace(/\{(\w+)\}/g, (_, k) => (data[k] != null ? String(data[k]) : ""));
}

export function discountAmount(d) {
  const hn = Number(d.harga_normal || 0);
  const nd = Number(d.nilai_diskon || 0);
  if (d.jenis_diskon === "Persentase") return Math.round((hn * nd) / 100);
  if (d.jenis_diskon === "Nominal") return nd;
  return 0;
}

export function computeFinal(d) {
  const hn = Number(d.harga_normal || 0);
  const homecare = Number(d.biaya_homecare || 0);
  const bahan = Number(d.biaya_bahan || 0);
  const pot = Number(d.potongan_lainnya || 0);
  return Math.round(hn + homecare + bahan - discountAmount(d) - pot);
}
